import styled from 'styled-components'

const TableBoldColumnContainer = styled.div`
  font-weight: 600;
  line-height: 22px;
`

export default TableBoldColumnContainer
